export const nonNullish = <T>(val: T | null | undefined, name = 'value'): T => {
  if (val === null || val === undefined) {
    throw new Error(
      `Expected ${name} to not be null or undefined, but was ${val}`,
    );
  }
  return val;
};
